import { useState } from 'react';
import { AxiosError, AxiosRequestConfig } from 'axios';
import useError from 'components/ErrorProvider/useError';
import { downloadFile } from 'helper';
import { exportPartnerRatingUgoByRealEstateExcel } from '../api';

export function useExportPartnerRatingUgoByRealEstateExcelReport() {
  const [loading, setLoading] = useState(false);

  const { addError } = useError();

  const exportPartnerRatingUgoByRealEstateExcelReport = async (
    partnerGuid: string,
    realEstateGuid: string,
    config?: AxiosRequestConfig,
  ) => {
    setLoading(true);

    try {
      downloadFile(
        await exportPartnerRatingUgoByRealEstateExcel(partnerGuid, realEstateGuid, config),
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Отчет по партнеру УГО и ЖК.xlsx',
      );
    } catch (error) {
      addError((error as AxiosError).response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return { loading, exportPartnerRatingUgoByRealEstateExcelReport };
}
